import { FormatDateShort } from "utils/dateUtils";
import { FormatNumberOrNull } from "utils/numberUtils";
import { MealType } from "Dashboard/scenes/Carnets/domain/MealType";
import { AbsenceType } from "Dashboard/scenes/Carnets/domain/AbsenceType";
import { IHourlyWorkWithLabel } from "Dashboard/domain/hourly_work/IHourlyWorkWithLabel";
import { selectState } from "Dashboard/scenes/HumanResources/scenes/payroll/payroll.slice";
import { useSelector } from "react-redux";
import { useMemorandumLogo } from "hooks/MemorandumLogo";

interface IProps {
  year: number;
  month: string;
}

const PrintCarnets = ({ year, month }: IProps) => {
  const memorandumLogo = useMemorandumLogo();
  const { carnets, totals } = useSelector(selectState);
  const carnetValueFormat = new Intl.NumberFormat("sr-SR",
    { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  return (
    <div className="carnetsPrintContainer">
      <div className="carnetsPrintHeader">
        <div className="logo">
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
        </div>
        <span>
          <h1>Pregled karneta za:</h1>
          <div>{month + " " + year}</div>
        </span>
      </div>
      <span className="printName">
        {carnets[0]?.employee.employeeName}
      </span>
      <table className="tableCarnetsTs tableHeaderCarnets">
        <tbody>
          <tr className="carnetsForEmployee"
            style={{ "--carnet-hour-columns": totals.hoursTotals.length } as React.CSSProperties}
          >
            <th>datum</th>
            {totals.hoursTotals.map((hoursItem: IHourlyWorkWithLabel) =>
              (<th key={hoursItem.index}>{hoursItem.label.toLowerCase()}</th>)
            )}
            <th>obrok</th>
            <th>keš obrok</th>
            <th>bolovanje</th>
            <th>odmor</th>
            <th>projekat</th>
          </tr>
        </tbody>
      </table>

      <table className="tableCarnetsTs carnetsT">
        <tbody>
          {carnets.map((carnet, index) => {
            return (
              <tr key={index} className="carnetsForEmployee"
                style={{ "--carnet-hour-columns": totals.hoursTotals.length } as React.CSSProperties}
              >
                <td>{carnet.carnetDate && FormatDateShort(carnet.carnetDate)}</td>
                {totals.hoursTotals.map((hoursItem, index) =>
                  <td key={hoursItem.index} className="hoursItem">
                    {FormatNumberOrNull(
                      carnet.hourlyWorkItems?.[index], carnetValueFormat) ?? ""}
                  </td>
                )}
                <td className="space-box">
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.breakfast === MealType.REGULAR}
                    readOnly
                  />
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.lunch === MealType.REGULAR}
                    readOnly
                  />
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.dinner === MealType.REGULAR}
                    readOnly
                  />
                </td>
                <td className="space-box">
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.breakfast === MealType.CASH}
                    readOnly
                  />
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.lunch === MealType.CASH}
                    readOnly
                  />
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.dinner === MealType.CASH}
                    readOnly
                  />
                </td>
                <td>
                  <input
                    className="no-clickable"
                    type="checkbox"
                    checked={carnet.absenceType === AbsenceType.SICK_LEAVE}
                    readOnly
                  />
                </td>
                <td>
                  <input
                    className="no-clickable red-checkmark"
                    type="checkbox"
                    checked={carnet.absenceType === AbsenceType.VACATION}
                    readOnly
                  />
                </td>
                <td className="multilineText justifyCenter">
                  {carnet.project?.projectName}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <table className="tableCarnetsTs tFooter">
        <tbody>
          <tr className="carnetsForEmployee"
            style={{ "--carnet-hour-columns": totals.hoursTotals.length } as React.CSSProperties}
          >
            <th></th>
            {totals.hoursTotals.map(hoursItem =>
              <th key={hoursItem.index}><div>{hoursItem.hours}</div></th>
            )}
            <th>
              <div>{totals.regularBreakfastsTotal}</div>
              <div>{totals.regularLunchesTotal}</div>
              <div>{totals.regularDinnersTotal}</div>
            </th>
            <th>
              <div>{totals.cashBreakfastsTotal}</div>
              <div>{totals.cashLunchesTotal}</div>
              <div>{totals.cashDinnersTotal}</div>
            </th>
            <th><div>{totals.sickLeavesTotal}</div></th>
            <th><div>{totals.vacationsTotal}</div></th>
            <th></th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PrintCarnets;
